/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const Container = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  padding: 80px 0;
  margin: 0 auto;
  align-items: center;
`;

export const InputForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  margin-bottom: 20px;
  width: 100%;
  gap: 24px;
`;

export const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const SpanEssential = styled.span`
  color: var(--alias-color-primary-normal);
  text-decoration: none;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PwEyeIconTouchPoint = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  top: 18px;
  right: 14px;
`;

export const AgreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
  width: 100%;
`;

export const LinkText = styled.p`
  text-decoration: underline;
  cursor: pointer;
`;

export const Line = styled.div`
  height: 1px;
  background-color: var(--alias-color-line-normal);
`;
